import React, { useEffect, useRef } from 'react';
import { useGoogleAdSense } from '@/hooks/useGoogleAdSense';

export interface AdSenseAdProps {
  slot: string;
  format?: 'auto' | 'rectangle' | 'leaderboard' | 'banner' | 'fluid';
  responsive?: boolean;
  style?: React.CSSProperties;
  className?: string;
  layoutKey?: string;
  layout?: string;
}

const AdSenseAd: React.FC<AdSenseAdProps> = ({
  slot,
  format = 'auto',
  responsive = true,
  style,
  className = '',
  layoutKey,
  layout
}) => {
  const { pushAd, isAdSenseEnabled, adsenseClientId } = useGoogleAdSense();
  const adRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (isAdSenseEnabled && adsenseClientId && adRef.current) {
      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
        pushAd();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [isAdSenseEnabled, adsenseClientId, pushAd]);

  // Don't render anything if AdSense is not enabled
  if (!isAdSenseEnabled || !adsenseClientId) {
    return null;
  }

  const adStyle: React.CSSProperties = {
    display: 'block',
    minWidth: '300px',
    minHeight: '250px',
    ...style
  };

  const adProps: Record<string, any> = {
    ref: adRef,
    className: `adsbygoogle ${className}`.trim(),
    style: adStyle,
    'data-ad-client': adsenseClientId,
    'data-ad-slot': slot,
    'data-ad-format': format,
    'data-full-width-responsive': responsive.toString()
  };

  // Add optional layout props
  if (layoutKey) {
    adProps['data-ad-layout-key'] = layoutKey;
  }
  if (layout) {
    adProps['data-ad-layout'] = layout;
  }

  return <ins {...adProps} />;
};

export default AdSenseAd; 